import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalHeaderComponent } from './modal-header/modal-header.component';
import { FinancialHealthFeatureComponent } from './financial-health-feature/financial-health-feature.component';
import { FinancialHealthFeatureCardComponent } from './financial-health-feature-card/financial-health-feature-card.component';
import { FinancialHealthProtectionCardComponent } from './financial-health-protection-card/financial-health-protection-card.component';
import { FinancialHealthChartComponent } from './financial-health-chart/financial-health-chart.component';
import { SharedModule } from '@shared/shared.module';

const DECLARATIONS = [
  ModalHeaderComponent,
  FinancialHealthFeatureComponent,
  FinancialHealthFeatureCardComponent,
  FinancialHealthProtectionCardComponent,
  FinancialHealthChartComponent
];

@NgModule({
  declarations: DECLARATIONS,
  exports: DECLARATIONS,
  imports: [CommonModule, SharedModule]
})
export class FinancialHealthComponentsModule {}
